module.exports = __webpack_public_path__ + "img/hotel-2.d938873d.jpeg";